import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=05a0cf3c&scoped=true&"
import script from "./Checklist.vue?vue&type=script&lang=js&"
export * from "./Checklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0cf3c",
  null
  
)

export default component.exports